export default "__VITE_ASSET__CqM93p4P__"